import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import Link from '../Link/index'
import { URL_AI_CHAT } from '../../services/url/constants'
import LogoSherpa2025 from '../Icon/icons/LogoSherpa2025/index'

function MemberHomeFirstTouchAiConversations ({
  auth = Map(),
  colorSchemePrefix,
  sessions,
  staticText = Map(),
}) {
  const items = useMemo(() => (
    Array.isArray(sessions) ? sessions : []
  ), [sessions])

  if (items.length === 0) {
    return null
  }

  const title = items.length > 1 ? staticText.get('lastConversations') : staticText.get('lastConversation')

  return (
    <div className="member-home-first-touch__ai-conversations">
      <div className={`member-home-first-touch__ai-conversations-title member-home-first-touch__ai-conversations-title--${colorSchemePrefix}`}>
        {title}
      </div>
      {items.map((session) => {
        const { id, name, personalityId } = session
        const trimmed = typeof name === 'string' ? name.trim() : ''
        const displayTitle = trimmed || id

        return (
          <Link
            key={id}
            className="member-home-first-touch__ai-conversation"
            to={URL_AI_CHAT}
            query={{
              chatSessionId: id,
              oraclePersonalityId: String(personalityId),
            }}
            auth={auth}
            title={displayTitle}
          >
            <LogoSherpa2025 size={25} className="member-home-first-touch__ai-conversation-icon"/>
            <span className="member-home-first-touch__ai-conversation-title">{displayTitle}</span>
          </Link>
        )
      })}
    </div>
  )
}

MemberHomeFirstTouchAiConversations.propTypes = {
  auth: ImmutablePropTypes.map,
  colorSchemePrefix: PropTypes.string.isRequired,
  sessions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    personalityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })),
}

MemberHomeFirstTouchAiConversations.defaultProps = {
  auth: Map(),
  sessions: [],
}

export default MemberHomeFirstTouchAiConversations
